// Sertifika Görselleri
import cert1 from '../image/WhatsApp Image 2026-02-24 at 11.33.33.jpeg';
import cert2 from '../image/Ekran görüntüsü 2026-02-20 143152.png';
import cert3 from '../image/Ekran görüntüsü 2026-02-20 143130.png';
import cert4 from '../image/Ekran görüntüsü 2026-01-27 171439.png';

const defaultContent = {
  navHome: "Home",
  navAbout: "About",
  navExp: "Experience",
  navVol: "Volunteering",
  navProj: "Projects",
  navCert: "Certificates",
  navContact: "Contact",
  headerTitle: "Computer Engineering Student",
  aboutTitle: "About Me",
  aboutText: "As a Computer Engineering student, I am focused on improving myself in mobile application development, open to learning, and have a strong problem-solving approach. I believe I will adapt to team work as someone who can grasp new technologies quickly, works with determination and high motivation.",
  eduTitle: "Education",
  uni1: "Balikesir University",
  dept: "Computer Engineering Department",
  uni2: "Harran University",
  gpa: "GPA : 2.44/4.00",
  skillsTitle: "Skills",
  skillsList: ["Flutter & Mobile App Development (Flutter, Dart)", "Web Development (React, Node.js)", "Database Management (Firebase)"],
  langTitle: "Languages",
  langList: ["Turkish (Native)", "English (Basic Level)", "Arabic (Basic Level)"],
  expTitle: "Experience",
  jobs: [
    { title: "TeknoAI-T", details: "Remote | Jan 2026 - Present", desc: "I continue to work at TeknoAI-T company.", icon: "/ikonlar/tenoai-t.jpg" },
    { title: "Iskur Youth Program", details: "Full Time | Mar 2025 - Jul 2025", desc: "I worked full time at the IT Department of Balikesir University Rectorate.\nThanks to this, I gained various experiences related to websites.", icon: "/ikonlar/iskur.png" }
  ],
  internships: [
    { title: "Internship at Balikesir Municipality", details: "Summer 2025", desc: "Worked on internal operational tasks and gained practical experience in project workflows and documentation.", icon: "/ikonlar/egitim.jpg" }
  ],
  volTitle: "Volunteering",
  volJobs: [
    { title: "T3 Foundation", details: "Volunteer | Sep 2025 - Present", desc: "I work as a volunteer at the Şanlıurfa T3 Foundation.", icon: "/ikonlar/t3.png" }
  ],
  projTitle: "Featured Projects",
  projects: [
    {
      id: 1,
      title: "Pazaryeri (Flutter)",
      description: "Mobile application providing neighborhood markets, product search and occupancy management. Developed using MVVM architecture, Provider, Firebase Auth/Firestore and Location services.",
      githubLink: "https://github.com/Ahmetoyann/Pazaryeri",
      icon: "/ikonlar/pazaryeri.png"
    },
    {
      id: 2,
      title: "OYN Music (Flutter)",
      description: "A modern and user-friendly music player application where you can listen to and discover music. Offers features such as trends, advanced search, background playback, favorites, playlists, cloud synchronization, and personalization. Developed using Flutter, Firebase Auth/Firestore, Provider, just_audio & audio_service, Jamendo API, and shared_preferences.",
      githubLink: "https://github.com/Ahmetoyann/oynmusic",
      icon: "/ikonlar/oyn_music.png"
    }
  ],
  certTitle: "Certificates",
  certificates: [
    { id: 1, title: "Project Writing Training", issuer: "Öğrenci Kariyeri", date: "February 2026", skills: "Software Project Management · Project writing · Project management", desc: "I am pleased to share that I have successfully completed the \"Project Writing Training Final\" program organized by Öğrenci Kariyeri.", image: cert1, icon: "/ikonlar/ogrencikariyeri_logo.jpg" },
    { id: 2, title: "Artificial Intelligence", issuer: "Istanbul Gelisim University", date: "January 2026 - February 2026", skills: "Artificial Intelligence · AI Supported Development", desc: "Artificial Intelligence certificate.", image: cert2, icon: "/ikonlar/istanbul_gelisim.jpg" },
    { id: 3, title: "Prompt Engineering", issuer: "Istanbul Gelisim University", date: "January 2026 - February 2026", skills: "Prompt Engineering", desc: "Prompt Engineering certificate.", image: cert3, icon: "/ikonlar/istanbul_gelisim.jpg" },
    { id: 4, title: "Dart Programming Language", issuer: "BTK Academy", date: "December 2025 - January 2026", skills: "Dart Language", desc: "I have successfully completed the Dart programming language training provided by BTK ACADEMY. Credential ID: eK1hOn6Y4p", image: cert4, icon: "/ikonlar/btk.png" }
  ],
  contactTitle: "Get in Touch",
  copyright: "All Rights Reserved.",
  modalTitle: "Get in Touch",
  formName: "Name Surname",
  formEmail: "Email",
  formMsg: "Message",
  formBtn: "Send",
  phName: "Your Name",
  phEmail: "example@email.com",
  phMsg: "Your message...",
  privacyTitle: "Privacy Policy",
  privacyText: "This website only redirects basic contact information such as name and email address submitted via the contact form to your device's email client solely for the purpose of getting back to you. Your personal data is not stored on our servers, is never shared with third parties or used for advertising. Site data (e.g., theme preference, language selection) is kept in your browser's local storage (LocalStorage)."
};

export default defaultContent;
